"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ddDivBy2 = void 0;
/**
 * Returns the result of dividing the given double-double by 2.
 * @param f a double-double precision floating point number
 */
function ddDivBy2(f) {
    return [f[0] / 2, f[1] / 2];
}
exports.ddDivBy2 = ddDivBy2;
//# sourceMappingURL=dd-div-by-2.js.map